<template>
    <div>
        <!-- Google Map Component for Stroke Group -->
        <gmap-map
            ref="gmap"
            :center="center"
            :zoom="zoom"
            style="width:100%;  height: 276px;" 
        >
            <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      // default to montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 0, lng: 0 },
      markers: [],
      places: [],
      currentPlace: null
    };
  },
  props: {
      zoom: {
          type:Number
      },
      address: {
          type:String
      }
  },
  mounted() {
    this.$refs.gmap.$mapPromise.then((map) => {
      this.searchLocation();
    })

  },

  methods: {
    
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    searchLocation: function() {
      this.currentPlace = {};
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({'address': this.address}, (results, status) => {
        if (status === 'OK') {
          this.currentPlace.lat = Number(results[0].geometry.location.lat());
          this.currentPlace.lng = Number(results[0].geometry.location.lng());
            const marker = {
            lat: this.currentPlace.lat,
            lng: this.currentPlace.lng
            };

            this.markers.push({ position: marker });
            this.places.push(this.currentPlace);
            this.center = marker;

        }
      });
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/GoogleMap.vue